import React from 'react'

const RsProStatusGroupPage = React.lazy(() => import('pages/RsProStatusGroup/RsProStatusGroupPage'));
const RsProStatusGroupAddPage = React.lazy(() => import('pages/RsProStatusGroup/RsProStatusGroupAddPage'));

const RsProStatusGroupRoutes = [
    {
        path: '/rs-pro-status-group',
        exact: true,
        name: 'Danh sách nhóm tình trạng máy',
        function: 'RS_PRO_STATUS_GROUP_VIEW',
        component: RsProStatusGroupPage,
    },
    {
        path: '/rs-pro-status-group/add',
        exact: true,
        name: 'Thêm mới nhóm tình trạng máy',
        function: 'RS_PRO_STATUS_GROUP_ADD',
        component: RsProStatusGroupAddPage,
    },
    {
        path: '/rs-pro-status-group/detail/:rs_pro_status_group_id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_PRO_STATUS_GROUP_VIEW',
        component: RsProStatusGroupAddPage,
    },
    {
        path: '/rs-pro-status-group/edit/:rs_pro_status_group_id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_PRO_STATUS_GROUP_EDIT',
        component: RsProStatusGroupAddPage,
    },
]

export default RsProStatusGroupRoutes
